<template>
  <div class="ns-calendar">
    <!-- Calendar header -->
    <div class="ns-calendar-header el-card flex items-center justify-between">
     <div class="flex items-center">
        <span style="margin-right: 25px;">
          <el-select v-model="selected_store" placeholder="Select store" size="medium" style="width: 250px; margin:0 15px" @change="storeChanged" filterable>
            <el-option v-for="item in store_lists" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </span>
        <div class="ns-calendar-head-left flex items-center ns-vutify">
          <span style="margin-right: 25px;">
            <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
              Today
            </v-btn>
          </span>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <!-- <i class="el-icon-arrow-left mx-1 cursor-pointer"></i> -->
          <!-- <i class="el-icon-arrow-right mx-1 cursor-pointer"></i> -->
          <p v-if="$refs.calendar" class="text-lg font-semibold" style="margin-left: 25px;"> {{ $refs.calendar.title }} </p>
        </div>
     </div>
      <div class="ns-calendar-head-left">
        <!-- Select View -->
        <el-select v-model="type" placeholder="Select view" size="medium" style="width: 115px; margin: 0 15px" @change="viewUpdated">
          <el-option v-for="item in all_views" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>

    <!-- Calendar vutify component -->
    <div class="ns-vutify">
      <v-row class="fill-height">
        <v-col>
          <v-sheet height="78vh">
            <v-calendar v-loading="loading_trainings" ref="calendar" v-model="focus" color="primary" :weekdays="weekdays"
              :events="computeTrainingSchedules" :event-color="getEventColor" :type="type" @click:event="showTraining"
              @click:more="showMoreTrainings" @click:date="viewDay" @click:day="createTraining" @click:time="createTraining" @change="updateRange">
                <template #event="{ event }">
                  <el-tooltip :content="event.training_name + ' ' + event.trainee_name + ' ' + event.training_time" placement="top" effect="light">
                  </el-tooltip>
                  <div class="ns-training-strip">
                      <strong>{{ event.training_name }}</strong>
                      {{ event.trainee_name }}
                      {{ event.training_time }}
                    </div>
              </template>
            </v-calendar>
          </v-sheet>
        </v-col>
      </v-row>
    </div>


    <!-- Show event card -->
    <!-- <div :style="cardStyle" class="w-full absolute ns-card" offset-x>
      <div class="ns-training-card-head flex items-center px-5 py-3">
        <i class="el-icon-edit text-lg mx-2"></i>
        <i class="el-icon-share text-lg mx-2"></i>
        <i class="el-icon-delete text-lg mx-2"></i>
      </div>
    </div> -->

    <el-dialog :title="Object.keys(selectedEvent).length ? selectedEvent.name : clicked_on_more ? 'All Trainings' : 'Training Schedule'"
      :visible.sync="selectedOpen" custom-class="ns-dialog" :width="clicked_on_more ? '20%' : '40%'" :before-close="handleClose">

      <template v-if="clicked_on_more">
        <div class="ns-cal-more-trainings">
          <ul>
            <li v-for="(training, training_index) in more_trainings" :key="training_index" @click="showTrainingFromMore(training)"> {{ training.name }} </li>
          </ul>
        </div>
      </template>

    <template v-else>
         <!-- Training form -->
      <el-row :gutter="15">
        <el-col :span="12">
          <p class="text-sm font-semibold my-2">Training Name <span style="color: red">*</span></p>
          <el-select v-model="selected_training_type" v-validate="'required'" placeholder="Select training name"
            name="Select training type" class="w-full" filterable >
            <el-option v-for="item in training_types" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <p>
            <span :v-show="errors.has(`Select training type`)" class="text-red-dark text-xs">
              {{ errors.first(`Select training type`) ? 'Required field' : '' }}
            </span>
          </p>
        </el-col>
        <el-col :span="12" style="margin-top: 40px">
          <!-- <el-tooltip content="Add Training" placement="top" effect="light">
            <span class="flex items-center cursor-pointer" @click="showNewTraining">
              <i class="el-icon-circle-plus-outline text-2xl text-amplitude font-bold"></i>
              <span class="text-amplitude font-semibold ml-1">Add New</span>
            </span>
          </el-tooltip> -->
        </el-col>
      </el-row>

      <el-row :gutter="15" class="mt-2">
        <el-col :span="12">
          <p class="text-sm font-semibold my-2">Trainee <span style="color: red">*</span></p>
          <el-select v-model="selected_trainee" v-validate="'required'" multiple collapse-tags placeholder="Select trainee" name="Select Trainee"
            class="w-full" filterable >
            <el-option v-for="item in traineeList" :key="item.id" :label="item.full_name" :value="item.id">
            </el-option>
          </el-select>
          <p>
            <span :v-show="errors.has(`Select Trainer`)" class="text-red-dark text-xs">
              {{ errors.first(`Select Trainer`) ? 'Required field' : '' }}
            </span>
          </p>
        </el-col>

        <el-col :span="12">
          <p class="text-sm font-semibold my-2">Training Buddy <span v-if="getTrainingName(selected_training_type).toLowerCase() !== 'practice day'" style="color: red" >*</span> </p>
          <el-select v-model="selected_trainer" v-validate="getTrainingName(selected_training_type).toLowerCase() === 'practice day' ? '' : 'required'" placeholder="Select training buddy" name="Select Training Buddy"
            class="w-full" filterable >
            <el-option v-for="item in trainerList" :key="item.id" :label="item.full_name" :value="item.id">
            </el-option>
          </el-select>
          <p>
            <span :v-show="errors.has(`Select Trainer`)" class="text-red-dark text-xs">
              {{ errors.first(`Select Trainer`) ? 'Required field' : '' }}
            </span>
          </p>
        </el-col>
      </el-row>

      <el-row :gutter="15" class="mt-2">
        <el-col :span="12">
          <p class="text-sm font-semibold my-2">Station <span style="color: red">*</span> </p>
          <el-select v-model="training_function" v-validate="'required'" placeholder="Select training station"
            name="Select training function" class="w-full" filterable >
            <el-option v-for="item in computedStations" :key="item.id" :label="item.function" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>

      <el-row :gutter="15" class="mt-2">
        <el-col :span="12">
          <p class="text-sm font-semibold my-2">Start Date <span style="color: red">*</span></p>
          <el-date-picker :key="initial_date" v-model="selected_start_date" v-validate="'required'" type="date" range-separator="To" :default-value="initial_date"
            :picker-options="pickerOptions" placeholder="Select start date" name="Select start date"
            end-placeholder="End date" style="width: 100% !important;">
          </el-date-picker>
          <p>
            <span :v-show="errors.has(`Select start date`)" class="text-red-dark text-xs">
              {{ errors.first(`Select start date`) ? 'Required field' : '' }}
            </span>
          </p>
        </el-col>
        <el-col :span="12">
          <p class="text-sm font-semibold my-2">End Date <span style="color: red">*</span></p>
            <el-date-picker :key="initial_date" v-model="selected_end_date" v-validate="'required'" type="date" range-separator="To" :default-value="initial_date"
              :picker-options="pickerOptions" placeholder="Select end date" name="Select End Date"
              end-placeholder="End date" style="width: 100% !important;">
            </el-date-picker>
            <p>
              <span :v-show="errors.has(`Select End Date`)" class="text-red-dark text-xs">
                {{ errors.first(`Select End Date`) ? 'Required field' : '' }}
              </span>
            </p>
        </el-col>
      </el-row>

      <el-row :gutter="15" class="mt-2">
        <el-col :span="12">
          <p class="text-sm font-semibold my-2">Start Time <span style="color: red">*</span> </p>
          <el-select v-model="selected_start_time"  v-validate="'required'"  placeholder="Select start time" style="width: 100%" filterable>
            <el-option
              v-for="time in timeOptions"
              :key="time.value"
              :label="time.label"
              :value="time.value"
            ></el-option>
          </el-select>
            <p>
              <span :v-show="errors.has(`Select start time`)" class="text-red-dark text-xs">
                {{ errors.first(`Select start time`) ? 'Required field' : '' }}
              </span>
            </p>
        </el-col>
        <el-col :span="12">
          <p class="text-sm font-semibold my-2">End Time <span style="color: red">*</span> </p>
          <el-select v-model="selected_end_time"  v-validate="'required'" placeholder="Select start time" style="width: 100%" filterable>
            <el-option
              v-for="time in timeOptions"
              :key="time.value"
              :label="time.label"
              :value="time.value"
            ></el-option>
          </el-select>
            <p>
              <span :v-show="errors.has(`Select End Time`)" class="text-red-dark text-xs">
                {{ errors.first(`Select End Time`) ? 'Required field' : '' }}
              </span>
            </p>
        </el-col>
      </el-row>

      <!-- Training form -->
      <span slot="footer" class="dialog-footer">
        <el-button  v-if="Object.keys(selectedEvent).length" class="ns-cancel-btn" @click="deleteTraining">Delete</el-button>
        <el-button class="ns-cancel-btn" @click="handleClose">Cancel</el-button>
        <el-button class="ns-primary-btn" @click="createUpdateTraining">{{ Object.keys(selectedEvent).length ? 'Update' :
          'Create' }}</el-button>
      </span>
    </template>
    </el-dialog>
    <!-- Show event card -->

    <!-- Create training -->
    <el-dialog
    title="Add/Update Training"
    :visible.sync="new_training"
    width="40%"
    custom-class="ns-dialog"
    :before-close="closeNewTraining">

    <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Add" name="add_training">Add</el-tab-pane>
      <el-tab-pane label="Edit" name="edit Training">Edit</el-tab-pane>
    </el-tabs> -->

    <template>
      <div>
        <el-row :gutter="15" class="mt-2">
          <el-col :span="12">
            <p class="text-sm font-semibold my-2">Training Name</p>
            <el-select v-if="is_edit_training" v-model="select_edit_training" v-validate="is_edit_training ? 'required' : ''" placeholder="Select training"
              name="Select training" class="w-full" filterable >
              <el-option v-for="item in training_types" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-input v-else v-model="training_name" placeholder="Enter training name" name="Training Name"></el-input>
            <p v-if="is_edit_training">
              <span :v-show="errors.has(`Select training`)" class="text-red-dark text-xs">
                {{ errors.first(`Select training`) ? 'Required field' : '' }}
              </span>
            </p>
            <p v-else>
              <span :v-show="errors.has(`Training Name`)" class="text-red-dark text-xs">
                {{ errors.first(`Training Name`) ? 'Required field' : '' }}
              </span>
            </p>
          </el-col>
          <el-col :span="12" style="margin-top: 40px">
            <el-tooltip content="Add Training" placement="top" effect="light">
              <span  v-if="is_edit_training" class="flex items-center cursor-pointer" @click="is_edit_training = false">
                <i class="el-icon-circle-plus-outline text-2xl text-amplitude font-bold"></i>
                <span class="text-amplitude font-semibold ml-1">Add New</span>
              </span>
              <span v-else class="flex items-center cursor-pointer" @click="is_edit_training = true">
                <img src="../../../assets/icons/edit-icon.svg" alt="Edit" width="20px">
                <span class="font-semibold ml-1 text-sm">Edit</span>
              </span>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="mt-2">
          <el-col :span="12">
            <p class="text-sm font-semibold my-2">Trainee Designation</p>
            <el-select v-model="trainee_designation" v-validate="'required'" placeholder="Select Trainee Designation" name="Select Trainee Designation"
              class="w-full" filterable >
              <el-option v-for="item in designations_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <p>
              <span :v-show="errors.has(`Select Trainee Designation`)" class="text-red-dark text-xs">
                {{ errors.first(`Select Trainee Designation`) ? 'Required field' : '' }}
              </span>
            </p>
          </el-col>

          <el-col :span="12">
            <p class="text-sm font-semibold my-2">Training Buddy Designation</p>
            <el-select v-model="trainer_designation" v-validate="'required'" placeholder="Select Training Buddy Designation" name="Select Training Buddy Designation"
              class="w-full" filterable >
              <el-option v-for="item in designations_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <p>
              <span :v-show="errors.has(`Select Training Buddy Designation`)" class="text-red-dark text-xs">
                {{ errors.first(`Select Training Buddy Designation`) ? 'Required field' : '' }}
              </span>
            </p>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="mt-2">
          <el-col :span="12">
            <p class="text-sm font-semibold my-2">Minimum Duration</p>
            <el-select v-model="minimum_duration" v-validate="'required'" placeholder="Minimum Duration" name="Minimum Duration"
              class="w-full" filterable >
              <el-option v-for="item in durationOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <p>
              <span :v-show="errors.has(`Minimum Duration`)" class="text-red-dark text-xs">
                {{ errors.first(`Minimum Duration`) ? 'Required field' : '' }}
              </span>
            </p>
          </el-col>
          <el-col :span="12">
            <p class="text-sm font-semibold my-2">Number of trainee</p>
            <el-input-number v-model="no_of_trainee" :min="1" :max="10" @change="handleChange"></el-input-number>
            <p>
              <span :v-show="errors.has(`Number of trainee`)" class="text-red-dark text-xs">
                {{ errors.first(`Number of trainee`) ? 'Required field' : '' }}
              </span>
            </p>
          </el-col>
        </el-row>
      </div>
    </template>

    <span slot="footer" class="dialog-footer">
      <el-button class="ns-cancel-btn" @click="closeNewTraining">Cancel</el-button>
      <el-button class="ns-primary-btn" @click="createUpdateTraining">Save</el-button>
    </span>
  </el-dialog>
    <!-- Create training -->
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import api from "../../../services/trainingServices"
export default {
  name: 'Calendar',
  data() {
    return {
      focus: '',
      type: 'month',
      timePickerOptions: {
        selectableRange: '00:00:00 - 23:59:59', // Set the time range as needed
        step: '00:30' // Set the step to 30 minutes
      },
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        // '4day': '4 Days',
      },
      weekdays: [
        1, 2, 3, 4, 5, 6, 0
      ],
      all_views: [
        {
          label: 'Month',
          value: 'month'
        },
        {
          label: 'Week',
          value: 'week'
        },
        {
          label: 'Day',
          value: 'day'
        },
        
        // {
        //   label: '4 Day',
        //   value: '4day'
        // }
      ],
      pickerOptions: {
        firstDayOfWeek: 1,
        format: 'HH:mm'
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      selected_date: '',
      show_create_training: false,
      cardStyle: {},
      selected_trainer: '',
      selected_training_type: '',
      selected_date_time: [],
      showCreateTraining: false,
      selected_trainee: [],
      trainee_coverage: '',
      trainer_coverage: '',
      training_function: '',
      start_date: '',
      end_date: '',
      initial_date: null,
      clicked_on_more: false,
      more_trainings: [],
      selected_start_date: '',
      selected_start_time: '',
      selected_end_date: '',
      selected_end_time: '',
      timeOptions: this.generateTimeOptions(),
      durationOptions: this.generateDurationOptions(),
      selected_store: '',
      new_training: false,
      minimum_duration: '',
      no_of_trainee: 1,
      trainer_designation: [],
      trainee_designation: [],
      training_name: '',
      select_edit_training: '',
      is_edit_training: false
    }
  },
  computed: {
    ...mapState('TrainingStore', ['training_schedules', 'training_types', 'store_employees', 'all_employees', 'store_stations', 'store_lists', 'loading_trainings', 'designations_list', 'store_sections', 'department_list']),
    computeTrainingSchedules() {
      let result = [...this.training_schedules];
      // Add employee details
      if (this.all_employees.length && result.length) {
        for (let e of result) {
          const trainingName = this.getTrainingName(e.training_type);
          const find_emp_details = (id) => this.all_employees.find((r) => r.id === id);
          e.trainee_details = find_emp_details(e.trainees[0]) ? find_emp_details(e.trainees[0]) : {full_name: 'NA'};
          e.trainer_details = find_emp_details(e.trainer) ? find_emp_details(e.trainer) : {full_name: 'NA'};
          e.start = new Date(e.start_date + 'T' + e.start_time);
          e.end = new Date(e.end_date + 'T' + e.end_datetime);
          e.name = trainingName + ' ' + e.trainee_details.full_name + ' - ' + moment(e.start_time, 'HH:mm:ss').format('hh:mm A');
          e.training_name = trainingName;
          e.trainee_name =e.trainee_details.full_name.charAt(0).toUpperCase() +e.trainee_details.full_name.slice(1).toLowerCase();
          e.training_time = moment(e.start_time, 'HH:mm:ss').format('hh:mm A') + ' - ' + moment(e.end_datetime, 'HH:mm:ss').format('hh:mm A');
          e.color = 'bg-training-primary';
          e.timed = true;
        }
      }
      return result;
    },
    trainerList() {
      let all_list = [...this.store_employees];
      return all_list.filter((e) => !this.selected_trainee.includes(e.id) && this.checkOtherConditions(e));
    },
    traineeList() {
      let all_list = [...this.store_employees];
      return all_list.filter((e) => e.id !== this.selected_trainer);
    },
    computedStations(){
      // const all_setup_sec = this.store_sections.flatMap(i => i.setups_for_section.filter(i2 => i2.enabled));
      let all_stations = [...this.store_stations];
      // all_stations = all_stations.filter((e)=> all_setup_sec.some((e1)=> e.id === e1.function) );
      // let all_setup_sec = [];
      // for (const i of this.store_sections) {
      //   for (const i2 of i.setups_for_section) {
      //     if(i2.enabled) {
      //       all_setup_sec.push(i2)
      //     }
      //   }
      // }
      return all_stations;
    }
  },
  mounted() {
    let storeId = localStorage.getItem('store_id');
    if(storeId){
      this.selected_store = storeId;
    }
    let calendar = localStorage.getItem('selected_training_date');
    if(calendar){
      calendar = JSON.parse(calendar);
      this.start_date = calendar.start_date;
      this.end_date = calendar.end_date;
      this.focus = calendar.end_date;
    }
    // First get all training types
    this.getStoreLists();
    this.getTrainingTypesAction();
    this.getTrainings();
    this.getStoreSectionsAction({store: storeId});
    this.getStoreStations({outlet_id: storeId});
    this.getDesignationAction({outlet_id: storeId});
    this.getDepartmentAction({outlet_id: storeId});
    // console.log(calendar, 'calendar')
    // Cell click event
    // Add a click event listener to the cell elements
    this.addClickEvent();
  },
  beforeDestroy() {
    // Remove the click event listener when the component is destroyed
    this.removeClickEvent();
  },
  methods: {
    ...mapActions('TrainingStore', ['getTrainingTypesAction', 'getTrainingsAction', 'getStoreEmpAction', 'getStoreStations', 'getStoreLists', 'getDesignationAction', 'getStoreSectionsAction', 'getDepartmentAction']),
    createUpdateTraining() {
      let payload = {
        id: null,
        store: this.selected_store,
        trainer: this.selected_trainer,
        trainees: this.selected_trainee,
        training_type: this.selected_training_type,
        training_function: this.training_function,
        trainer_coverage: '',
        trainee_coverage: ''
      };

      payload.start_date = moment(this.selected_start_date).format('YYYY-MM-DD')
      payload.end_date = moment(this.selected_end_date).format('YYYY-MM-DD')
      payload.start_time = this.selected_start_time + ':00';
      payload.end_datetime = this.selected_end_time + ':00';

      if (Object.keys(this.selectedEvent).length) {
        payload.id = this.selectedEvent.id;
      }

      // Validate first
      this.$validator.validateAll().then((result) => {
        if (result) {
          api.createUpdateTrainings(payload).then((res) => {
            this.$notify.success({
              title: 'Success',
              message: 'Training schedule created!'
            });
            this.selectedOpen = false
            this.getTrainings();
            this.clearData();
          }).catch((err) => {
            let err_message = JSON.parse(err.response.data)
            console.log(err.response.data);
            console.log(err_message);
            this.$notify.error({
              title: 'Oops!',
              message: err_message.msg
            });
          });
        } else {
          this.$notify.error({
            title: 'Oops!',
            message: 'Please enter required fields!'
          });
        }
      });
    },
    checkOtherConditions(emp) {
      if (emp) {
        const department = this.department_list.find((e) => e.id === emp.store_department);

        if (department) {
          const empDepartment = department.department;
          const empDesignation = Object.keys(emp.designation_info).length ? emp.designation_info.name : '';

          return (
            empDepartment.toLowerCase() === 'management' ||
            empDesignation.toLowerCase() === 'ct' ||
            empDesignation.toLowerCase() === 'crew trainer'
          );
        }
      }

      // Handle the case where emp is not defined or the department is not found
      return false;
    },
    generateTimeOptions() {
      const options = [];
      for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 30) {
          const formattedHour = String(hour).padStart(2, '0');
          const formattedMinute = String(minute).padStart(2, '0');
          options.push({label:moment(`${formattedHour}:${formattedMinute}`, 'HH:mm').format('hh:mm A'), value:`${formattedHour}:${formattedMinute}`});
        }
      }
      return options;
    },
    generateDurationOptions() {
      const timeArray = [];
      for (let i = 1; i <= 24; i += 0.5) {
        const hours = Math.floor(i);
        const minutes = i % 1 === 0.5 ? '30' : '00';

        const timeObject = {
          label: i + ' Hrs',
          value: `${hours.toString().padStart(2, '0')}:${minutes}`,
        };

        timeArray.push(timeObject);
      }
      return timeArray;
    },
    getTrainingName(id){
      let result = '';
      let data = [...this.training_types];
      data = data.find((e)=> e.id === id);
      if(data){
        result = data.name;
      }
      return result;
    },  
    deleteTraining(){
      let payload = {ids:[]};

      if (Object.keys(this.selectedEvent).length) {
        payload.ids.push(this.selectedEvent.id);
      }else {
        return;
      }

      api.deleteTraining(payload).then((res) => {
        this.$notify.success({
          title: 'Success',
          message: 'Training deleted!'
        });
        this.selectedOpen = false
        this.getTrainings();
        this.clearData();
      }).catch((err) => {
        console.error(err);
        this.$notify.error({
          title: 'Oops!',
          message: 'Something went wrong!'
        });
      })
    },
    getTrainings() {
      let start_date = '';
      let end_date = '';
      // let store_id = '';
      let store_id = this.selected_store;
      if (this.$refs.calendar.type === 'month') {
        this.getMonthStartAndEndDate(this.$refs.calendar.title);
        start_date = this.start_date;
        end_date = this.end_date;
      } else if (this.$refs.calendar.type === 'week') {
        this.getMonthStartAndEndDate(this.$refs.calendar.title);
        start_date = this.start_date;
        end_date = this.end_date;
      } else {
        this.getMonthStartAndEndDate(this.$refs.calendar.title);
        start_date = this.start_date;
        end_date = this.end_date;
      }
      let payload = { start_date, end_date, store_id };
      // console.log(payload, 'payload')
      // await this.getStoreEmpAction({ outlet_id: this.selected_store });
      // Store date in local storage
      localStorage.setItem('selected_training_date', JSON.stringify({start_date: this.start_date, end_date: this.end_date}));
      this.getTrainingsAction(payload);
    },
    viewDay({ date }) {
      console.log(date, 'date');
      this.createTraining({ date });
    },
    showTraining({ nativeEvent, event }) {
      console.log(nativeEvent.target, 'nativeEvent');
      this.selectedEvent = event;
      this.selectedElement = nativeEvent.target;
      // Set datetime
      // this.selected_date_time = [event.start, event.end];
      this.selected_start_date = event.start_date;
      this.selected_start_time = event.start_time.split(':').slice(0, 2).join(":");
      this.selected_end_date = event.end_date;
      this.selected_end_time = event.end_datetime.split(':').slice(0, 2).join(":");
      this.selected_trainer = event.trainer;
      this.selected_training_type = event.training_type;
      this.trainer_coverage = event.trainer_coverage;
      this.selected_trainee = event.trainees;
      this.trainee_coverage = event.trainee_coverage;
      this.training_function = event.training_function;
    },
    showTrainingFromMore(event) {
      this.selectedEvent = event;
      // this.selectedElement = nativeEvent.target;
      // Set datetime
      // this.selected_date_time = [event.start, event.end];
      this.selected_start_date = event.start_date;
      this.selected_start_time = event.start_time.split(':').slice(0, 2).join(":");
      this.selected_end_date = event.end_date;
      this.selected_end_time = event.end_datetime.split(':').slice(0, 2).join(":");
      this.selected_trainer = event.trainer;
      this.selected_training_type = event.training_type;
      this.trainer_coverage = event.trainer_coverage;
      this.selected_trainee = event.trainees;
      this.trainee_coverage = event.trainee_coverage;
      this.training_function = event.training_function;
      this.clicked_on_more = false;
      this.selectedOpen = true;
      this.$forceUpdate();
    },
    showMoreTrainings(event) {
      console.log(event, 'more');
      this.clicked_on_more = true;
      let all_trainings = [...this.computeTrainingSchedules]
      // Set more trainings
      this.more_trainings = all_trainings.filter((t)=> t.start_date === event.date);
    },
    createTraining(event) {
      // Remove all validation errors first
      this.errors.items = [];
     console.log('event',event)
    //  Check weather the have training or not
      const training = this.computeTrainingSchedules.find((e) => e.start_date === event.date);
      if(!training){
        this.clearData();
      }
      // Calculate the date based on the cell's position or attributes
      // let cellDate = this.calculateDateFromCell(cell);
      this.selected_start_date = event.date;
      this.selected_end_date = event.date;
      if(this.type !== 'month'){
        this.selected_start_time = this.roundTimeToNearestHour(event.time);
        // this.selected_end_time = this.roundTimeToNearestHour(event.time);
      }
      // console.log(cellDate, moment(cellDate).format("YYYY-MM-DD"), 'cellDate');
      // this.selected_date_time = [cellDate];
      this.selectedOpen = true;
      this.showCreateTraining = true;
    },
    roundTimeToNearestHour(time) {
      // Split the time into hours and minutes
      const [hour, minute] = time.split(':').map(Number);

      // Calculate the rounded hour
      let roundedHour;
      if (minute < 30) {
        roundedHour = hour;
      } else {
        roundedHour = hour + 1;
      }

      // Format the rounded hour as 'HH:00'
      const roundedTime = `${String(roundedHour).padStart(2, '0')}:00`;

      return roundedTime;
    },
    getEventColor(event) {
      return event.color
    },
    showTrainingName(event) {
      return `${event.input.training_name + ' ' + event.input.trainee_name + ' - ' + event.input.training_time}`
    },
    setToday() {
      this.focus = ''
    },
    async prev() {
      await this.$refs.calendar.prev();
      this.getTrainings();
    },
    async next() {
      await this.$refs.calendar.next();
      this.getTrainings();
    },
    viewUpdated() {
      this.$nextTick(() => {
        this.getTrainings();
      });
    },
    storeChanged(){
      localStorage.setItem('store_id', this.selected_store);
      localStorage.setItem('store', this.selected_store);
      localStorage.setItem('store_name', this.selected_store);
      this.$nextTick(() => {
        this.getTrainings();
        this.getStoreSectionsAction({store: this.selected_store});
        this.getStoreStations({outlet_id: this.selected_store});
        this.getDesignationAction({outlet_id: this.selected_store});
        this.getDepartmentAction({outlet_id: this.selected_store});
      });
    },
    addClickEvent(){
      return;
      const calendar = this.$refs.calendar;
      if (calendar) {
        const selector = calendar.type === 'month'
          ? ['.v-calendar-weekly__day']
          : ['.v-calendar-daily__day-interval', '.v-event-timed-container'];

        // Remove any existing event listeners to avoid duplicate registrations
        calendar.$el.querySelectorAll(selector.join(', ')).forEach((cell) => {
          cell.removeEventListener('click', this.createTraining, true);
        });

        // Attach event listener to the selected elements
        calendar.$el.querySelectorAll(selector.join(', ')).forEach((cell) => {
          cell.addEventListener('click', this.createTraining, true);
        });
      }
    },
    removeClickEvent(){
      const calendar = this.$refs.calendar;
      if (calendar) {
        const selector = calendar.type === 'month'
          ? ['.v-calendar-weekly__day']
          : ['.v-calendar-daily__day-interval', '.v-event-timed-container'];

        // Remove event listeners from the selected elements
        calendar.$el.querySelectorAll(selector.join(', ')).forEach((cell) => {
          cell.removeEventListener('click', this.createTraining, true);
        });
      }
    },
    getMonthStartAndEndDate(monthYearString) {
      const monthYear = moment(monthYearString, "MMMM YYYY");
      const startDate = monthYear.startOf('month').format("YYYY-MM-DD");
      const endDate = monthYear.endOf('month').format("YYYY-MM-DD");
      this.start_date = startDate;
      this.end_date = endDate;
      this.initial_date = new Date(moment(startDate, 'YYYY-MM-DD').format());
      // this.initial_date = new Date(2023, 10, 1)
    },
    updateRange({ start, end }) {
      const events = []

      const min = new Date(`${start.date}T00:00:00`)
      const max = new Date(`${end.date}T23:59:59`)
      const days = (max.getTime() - min.getTime()) / 86400000
      const eventCount = this.rnd(days, days + 20)

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0
        const firstTimestamp = this.rnd(min.getTime(), max.getTime())
        const first = new Date(firstTimestamp - (firstTimestamp % 900000))
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
        const second = new Date(first.getTime() + secondTimestamp)

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: 'bg-training-primary',
          timed: !allDay,
        })
      }

      this.events = events
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    calculateDateFromCell(cell) {
      // Get the day of the month from the cell's content
      const dayOfMonth = parseInt(cell.textContent, 10);
      console.log(cell.textContent,cell, 'cell.textContent')
      if (!isNaN(dayOfMonth)) {
        // Create a new Date object for the clicked day
        const currentDate = new Date();

        // Set the year and month to match the currently displayed calendar
        currentDate.setDate(dayOfMonth);

        // Return the calculated date
        return currentDate;
      } else {
        // Return null or handle the case where the day cannot be determined
        return null;
      }
    },
    showNewTraining(){
      this.new_training = true;
      this.handleClose();
    },
    clearData(){
      this.selected_start_date = '';
      this.selected_start_time = '';
      this.selected_end_date = '';
      this.selected_end_time = '';
      this.selected_trainer = '';
      this.selected_trainee = [];
      this.selected_training_type = '';
      this.trainer_coverage = '';
      this.training_function = '';
    },
    handleClose() {
      this.clicked_on_more = false;
      this.selectedOpen = false;
      this.selected_trainer = '';
      this.selectedEvent = {};
      this.selectedElement = '';
      this.selected_start_date =  '';
      this.selected_start_time =  '';
      this.selected_end_date = '';
      this.selected_end_time =  '';
      this.selected_trainer = '';
      this.selected_trainee = [];
      this.selected_training_type = '';
      this.trainer_coverage = '';
      this.training_function = '';
    },
    closeNewTraining(){
      this.new_training = false;
    },
    capitalizeFirstLetterIgnoringSpaces(string) {
      let startIndex = 0;
      while (startIndex < string.length && string[startIndex] === ' ') {
        startIndex++;
      }
      const capitalizedFirstChar = string.charAt(startIndex).toUpperCase();
      const restOfString = string.slice(startIndex + 1);
      return string.substring(0, startIndex) + capitalizedFirstChar + restOfString;
    }
  },
}
</script>
<style scoped>
@import "../../../plugins/vuetify.min.css";

.ns-card {
  background: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  width: 450px;
}
</style>

<style lang="scss">
.ns-calendar-header {
  margin: 15px 0 25px 0;
  padding: 15px 15px;
  border-radius: 8px;
}

.v-calendar-weekly__head-weekday {
  line-height: 25px;
}

.bg-training-primary {
  color: #fff;
  background: rgb(121, 134, 203);
}

.v-calendar-weekly__day, .v-calendar-daily__day-interval {
  cursor: pointer;
}


.ns-dialog .el-dialog__header {
  background: #fdfdfd;
  color: #1c1b1b;
  padding: 25px 20px;
  border-radius: 8px;
}

.ns-dialog.el-dialog {
  border-radius: 8px;
}

.ns-dialog .el-dialog__title {
  text-transform: capitalize;
  color: #1c1b1b;
  font-weight: 700;
}

.ns-dialog .el-dialog__footer {
  /* position: fixed; */
  bottom: 0;
  width: 100%;
  padding: 15px 35px;
  background: #fff;
  border-radius: 8px;
}

.ns-dialog .el-dialog__body {
  padding: 5px 20px 30px 20px !important;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.ns-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #000000;
  font-weight: 600;
  font-size: 25px;
}

.ns-primary-btn {
  background: #e6a23c;
  color: #fff;
  border-color: #e6a23c;
}

.ns-primary-btn:hover {
  background: #fff;
  color: #e6a23c;
  border-color: #e6a23c;
}

.ns-cancel-btn:hover {
  background: #fff;
  color: #e6a23c;
  border-color: #e6a23c;
}
.primary{
  color: #e6a23c !important;
  font-weight: 700 !important;
}
.ns-cal-more-trainings ul {
  list-style: none;
  padding: 0;
}

.ns-cal-more-trainings ul li {
  padding: 5px 15px;
  background: rgb(121, 134, 203);
  color: #fff;
  margin: 5px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
}
.ns-training-strip{
  padding-left: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-event.v-event-start.v-event-end.bg-training-primary.white--text {
    margin-left: 6px;
    @media screen and (max-width: 1200px) {
      margin-left: 4px;
    }
}
</style>